import React from 'react';

import Box from '@mui/material/Box';
import CircleIcon from '@mui/icons-material/Circle';
import DeleteIcon from '@mui/icons-material/Delete';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SessionTypeFormV2 from './SessionTypeV2Form';

import {getServiceCategories} from '../../helpers/selectOptions';
import {useRemoveSessionTypeMutation} from '../../redux/services/sessionTypeApi';
// import {calculateSessionCharge} from '../../helpers/sessions';

const handleDelete = ({remove, sessionTypeId}) => async e => {
  if (window.confirm('Are you sure you want to delete this session type? This action cannot be undone.')) {
    await remove({id: sessionTypeId});
  }
};

const SessionTypeDetailsV2 = ({
  sessionType
}) => {
  const [remove] = useRemoveSessionTypeMutation();
  if (!sessionType) return null;
  const onDelete = handleDelete({remove, sessionTypeId: sessionType.id});
  const serviceCategory = sessionType?.service_category;
  return (
    <Box>
      <Stack direction='row' justifyContent='space-between'>
        <Typography variant='h1'>Service Type Details</Typography>
        <IconButton color='error' onClick={onDelete}>
          <DeleteIcon />
        </IconButton>
      </Stack>
      <Stack direction='row' spacing={1}>
        <CircleIcon 
          style={{
            fontSize: '1rem', 
            color: getServiceCategories().find(c => c.value === serviceCategory)?.color
          }}
        />
        <Typography variant='h2'>
          {
            getServiceCategories().find(c => c.value === serviceCategory)?.label
            ||  sessionType?.name
          }
        </Typography>
      </Stack>
      <Stack py={1}>
        <Divider />
      </Stack>
      <SessionTypeFormV2
        key={sessionType.id} // force remount when selectedId changes
        isEditing={true}
        sessionType={sessionType}
      />
    </Box>
  );
};

export default SessionTypeDetailsV2;